import { ApiError } from '@/shared/api/api-client/api-error';
import { API_ACCOUNT_NOTIFICATIONS } from '@/shared/constants/bff-endpoints';


export async function markNotificationRead (id: string): Promise<void> {
    const res = await fetch(`${ API_ACCOUNT_NOTIFICATIONS }${ encodeURIComponent(id) }/`, {
        method : 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body   : JSON.stringify({ read: true }),
    });

    if (!res.ok) {
        const errorData = await res.json().catch(() => ({}));

        throw new ApiError(res.status, errorData);
    }
}
